import React, { FC } from "react";
import { Card } from "@UI/Components/Card/Card";
import { PaymentError } from "@modules/Purchasing/Components/OrderDescription/PaymentError/PaymentError";
import { BankTransferInformations } from "@modules/PaymentProcessing/modules/BankTransfer/Components/PayByBankTransfer/Adapters/CompanyOperations/BankTransferInformations";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";
import { IAppCurrency } from "@App/types";
import useI18n from "@I18n/hooks/useI18n";

interface Props {
  amountCents: number;
  currency: IAppCurrency;
}

export const LatePaymentBankTransfer: FC<Props> = ({
  amountCents,
  currency,
}) => {
  const { formatNumber } = useI18n();
  return (
    <Card>
      <PaymentError
        title={<FormattedMessage {...messages.transferNotMade} />}
        message={
          <FormattedMessage
            {...messages.transferErrorMessage}
            values={{ amountCents: formatNumber(amountCents / 100) }}
          />
        }
      >
        <Card
          w="full"
          background="sand.100"
          p="4"
          rounded="md"
          shadow="none"
          mb={{ md: "3" }}
        >
          <BankTransferInformations
            amountCents={amountCents}
            currency={currency}
          />
        </Card>
      </PaymentError>
    </Card>
  );
};
